const splitString = (text: { name: string }) =>
  text.name.replace('  ', ' ').split(' ')[1] || text.name;
const prepareString = (text: { name: string }, split = false) =>
  (split ? splitString(text) : text.name).toLocaleLowerCase();

export const sortByFullName = (
  a: { firstName?: string; lastName?: string },
  b: { firstName?: string; lastName?: string },
  reverse = false,
): number => {
  if (!a.lastName || !b.lastName) return 0;
  if (!a.firstName || !b.firstName) return 0;

  const aLast = a.lastName.toLocaleLowerCase();
  const bLast = b.lastName.toLocaleLowerCase();

  if (aLast < bLast) return reverse ? 1 : -1;
  if (aLast > bLast) return reverse ? -1 : 1;

  const aFirst = a.firstName.toLocaleLowerCase();
  const bFirst = b.firstName.toLocaleLowerCase();

  if (aFirst < bFirst) return reverse ? 1 : -1;
  if (aFirst > bFirst) return reverse ? -1 : 1;

  return 0;
};

export default (
  a: { name: string },
  b: { name: string },
  split = false,
  reverse = false,
): number => {
  if (reverse) {
    return prepareString(a, split) < prepareString(b, split) ? 1 : -1;
  }
  return prepareString(a, split) < prepareString(b, split) ? -1 : 1;
};
